import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/page.tsx");
